import state from './state'

export default {
    getSmscList() {
      return state.smscList;
    },
  
    getTotalPages() {
      return state.totalPage;
    },

    getTotal() {
      return state.totalItems;
    },
    
    getSmsc() {
      return state.smsc;
    }
  
};